import {getUser} from 'src/modules/admin/services';
import {useAppSelector} from 'src/store';

import {LocalStorage} from '@pb/kit-util-client-storage';

export const useUserEmail = () => {
    return (useAppSelector(getUser)?.email ?? LocalStorage.get('user')?.email) || '';
};
